import {lazy, filter} from './lang.js';
import {doc} from './documentation.js';

// given a chord on one step, it will split the triggers
// and apply the args to this
// poly(switchOutput(0), switchOutput(1))
doc(
    "poly",
    {
        "args": "Arguments to be evaluated",
    },
    "Splits a chord among the arguments passed. poly(switchOutput(0), switchOutput(1)) will send half the notes in a chord to output 0 and the others to output 1"
);
export const poly = (...args) => {
    let counter = undefined;
    let lastStepNumber = undefined;
    return (stepData, stepNumber, time) => {
        if (lastStepNumber !== stepNumber) {
            counter = -1;
        }
        counter++;
        lastStepNumber = stepNumber;
        return lazy(args[counter%args.length], stepData, stepNumber, time);
    };
};
